import { Input, Form } from 'antd';
import { dermatologyMarkTypes, calculateCounts } from './dermatologyUtils';

const DermatologyLegend = ({ marks, disabled, otherText, onOtherTextChange, otherQuestion }) => {
  const counts = calculateCounts(marks);
  const hasOthers = counts.COUNT_OTHERS > 0;

  return (
    <div className="dermatology-legend">
      <div className="dermatology-legend-title">LEYENDA</div>
      <div className="dermatology-legend-subtitle">
        MARCAR CON LA LETRA CORRESPONDIENTE, LA ZONA DE UBICACIÓN AL LADO DE LA CARACTERÍSTICA. EL NÚMERO DE OBSERVACIONES ENCONTRADAS.
      </div>
      
      <div className="dermatology-legend-summary">
        {Object.entries(dermatologyMarkTypes).map(([key, value]) => (
          <div key={key} className="dermatology-legend-item">
            {key} = {value.label} <span style={{ color: value.color }}>{counts[value.code] || 0}</span>
          </div>
        ))}
      </div>

      {hasOthers && otherQuestion && (
        <div className="dermatology-others-field">
          <Form.Item
            label="Especifique a qué se refiere con 'Otras' marcas:"
            name={['questions', otherQuestion.id.toString()]}
          >
            <Input.TextArea
              rows={2}
              placeholder="Describa las otras marcas encontradas"
              value={otherText}
              onChange={(event) => onOtherTextChange(event.target.value)}
              disabled={disabled}
            />
          </Form.Item>
        </div>
      )}
    </div>
  );
};

export default DermatologyLegend;
